import React from 'react'

export const formatColumnTitle = (text) => {
  const words = text.split(' ')
  const [firstWord, ...restWords] = words
  return (
    <p style={{ margin: 0, whiteSpace: 'pre-line' }}>
      {firstWord.charAt(0).toUpperCase() + firstWord.slice(1)}
      {restWords.length > 0 ? `\n${restWords.join('\n')}` : ''}
    </p>
  )
}
